import { Palette } from '../constants/palette';
export const input = {
    backgroundColor: Palette.white,
    color: Palette.darkBlue,
    disabledColor: Palette.gray80,
    borderColor: Palette.gray80,
    borderFocusColor: Palette.black,
    borderHoverColor: Palette.darkBlue,
    errorColor: Palette.red,
    focusedColor: Palette.darkBlue,
    helperColor: Palette.gray40,
    labelColor: Palette.gray40,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5wdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvaW5wdXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBRy9DLE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBbUI7SUFDbkMsZUFBZSxFQUFFLE9BQU8sQ0FBQyxLQUFLO0lBQzlCLEtBQUssRUFBRSxPQUFPLENBQUMsUUFBUTtJQUN2QixhQUFhLEVBQUUsT0FBTyxDQUFDLE1BQU07SUFDN0IsV0FBVyxFQUFFLE9BQU8sQ0FBQyxNQUFNO0lBQzNCLGdCQUFnQixFQUFFLE9BQU8sQ0FBQyxLQUFLO0lBQy9CLGdCQUFnQixFQUFFLE9BQU8sQ0FBQyxRQUFRO0lBQ2xDLFVBQVUsRUFBRSxPQUFPLENBQUMsR0FBRztJQUN2QixZQUFZLEVBQUUsT0FBTyxDQUFDLFFBQVE7SUFDOUIsV0FBVyxFQUFFLE9BQU8sQ0FBQyxNQUFNO0lBQzNCLFVBQVUsRUFBRSxPQUFPLENBQUMsTUFBTTtDQUMzQixDQUFDIn0=